module.exports = __webpack_public_path__ + "static/media/special-offer-banner.c55d10dd.jpg";